import { Component, Input, TemplateRef, ViewChild } from '@angular/core';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { ExpenseAttributes } from '@albatrosdeveloper/ave-models-package';
import { MatDialog, MatDialogContent, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ExpenseLoadListComponent } from '../expense-load-list/expense-load-list.component';

interface ExpenseGrouped {
  reasonName: string;
  totalAmount: number;
  expenses: ExpenseAttributes[];
}

@Component({
  selector: 'app-expense-totals-tab',
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    MatDialogModule,
    ExpenseLoadListComponent,
    MatDialogContent
  ],
  templateUrl: './expense-totals-tab.component.html',
})
export class ExpenseTotalsTabComponent {
  @Input() tripId: number = 0;
  @Input() expenses: MatTableDataSource<ExpenseAttributes> = new MatTableDataSource<ExpenseAttributes>([]);
  @Input() totalUnit: string = '';
  @Input() showActions: boolean = true;

  public groupedExpenses: ExpenseGrouped[] = [];
  public displayedColumns: string[] = ['reasonName', 'totalAmount'];

    @ViewChild("detailModal") detailModal!: TemplateRef<any>;
  dialogRefDetailModal: MatDialogRef<any>;

  reasonNameGlobal: string = "";

  constructor(private dialog: MatDialog) {}

  ngOnChanges() {
    if (this.expenses?.data?.length) {
      this.groupData();
    }
  }

  private groupData() {
    const grouped: Record<string, ExpenseGrouped> = {};

    for (const expense of this.expenses.data) {
      const reason = expense.reasonForExpense?.name ?? 'Sin motivo';
      if (!grouped[reason]) {
        grouped[reason] = { reasonName: reason, totalAmount: 0, expenses: [] };
      }
      grouped[reason].totalAmount += expense.amount ?? 0;
      grouped[reason].expenses.push(expense);
    }

    this.groupedExpenses = Object.values(grouped);
  }

  get totalGeneral(): number {
    return this.groupedExpenses.reduce((sum, g) => sum + g.totalAmount, 0);
  }

  openHistoryModal(reasonName: string) {
    this.reasonNameGlobal = reasonName;

    this.dialogRefDetailModal = this.dialog.open(this.detailModal, {
      width: "95%",
      maxWidth: "145vh",
      maxHeight: "95vh",
      panelClass: "custom-dialog-container",
      disableClose: true
    });
  }
}
